import type { TimelineNode } from '@/types';

interface VerticalTimelineProps {
  nodes: TimelineNode[];
}

const stageClass: Record<string, string> = {
  起点: 'bg-secondary-100 text-secondary-800',
  发酵: 'bg-accent-100 text-accent-800',
  回应: 'bg-primary-100 text-primary-700',
  结局: 'bg-foreground-900 text-background-50',
};

export default function VerticalTimeline({ nodes }: VerticalTimelineProps) {
  return (
    <ol className="space-y-0">
      {nodes.map((node, index) => (
        <li key={`${node.date}-${node.title}`} className="flex gap-4 md:gap-6">
          <div className="flex flex-col items-center">
            <span className="z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-primary-400 bg-background-50 font-heading text-xs font-bold text-primary-600">
              {index + 1}
            </span>
            {index < nodes.length - 1 && <span className="w-px flex-1 bg-background-300" />}
          </div>
          <div className={`flex-1 ${index < nodes.length - 1 ? 'pb-8' : ''}`}>
            <div className="flex flex-wrap items-center gap-2">
              <time className="font-label text-sm font-medium text-foreground-950">{node.date}</time>
              <span
                className={`rounded-full px-2 py-0.5 font-label text-xs ${
                  stageClass[node.stage] ?? 'bg-background-200 text-foreground-700'
                }`}
              >
                {node.stage}
              </span>
            </div>
            <h4 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
              {node.title}
            </h4>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.description}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}